<template>
  <div class="input-item-wrap">
    <el-input v-model="value" class="input-item"  :type="config.componentType||'text'" :placeholder="getLocaleText(config.placeholder || '請選擇')">
      <template  v-if="config.btnText" #append>
      <el-button
       
        @click="search"
 
      >{{ getLocaleText(config.btnText) }}</el-button>
      </template>
    </el-input>
  </div>
</template>
  
  <script setup>
import { ref, watch, onMounted, onBeforeUnmount, computed } from "vue";
import useLocate from "./uses/useLocate.js";
import { useRenderConfig } from "./uses/useRenderConfig.js";
import { resolveBindDataKeyValue } from "@/utils/renderBinding";
// props 声明
const props = defineProps({
  currentElementIndex: {
    type: Array,
    default: () => []
  },
  idx: {
    type: Number,
    default: -1
  },
  parentKeys: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: true
  },
  config: {
    type: Object
  }
});
let emit = defineEmits(["change"]);
// 响应式数据
const value = ref("");
let lastName = ref("");
const { bindData } = useRenderConfig(() => props.config);
const bindDefaultValue = computed(() => {
  return resolveBindDataKeyValue(
    bindData.value,
    props.config?.bindDataKey,
    "",
  );
});

// 计算属性
const currentElementIndexStr = computed(() => {
  return props.currentElementIndex && props.currentElementIndex.length
    ? props.currentElementIndex.join("x")
    : "";
});

// watch 监听
watch(
  () => props.config,
  config => {
    if (config.name !== lastName.value) {
      if (!window.pageFields) {
        window.pageFields = {};
      }
      window.pageFields[config.name] = {
        setValue,
        getValue
      };
      lastName.value = config.name;
      // 清理旧的配置
      delete window.pageFields[lastName.value];
      delete window[`on${config.name}ValueChange`];
    }
  },
  { deep: true }
);

watch(value, v => {
  if (typeof window[`on${props.config.name}ValueChange`] === "function") {
    window[`on${props.config.name}ValueChange`](v);
  }
  if (!props.config.btnText) {
    emit("change", v);
  }
});

watch(
  bindDefaultValue,
  (nextValue) => {
    if (nextValue !== value.value) {
      value.value = nextValue;
    }
  },
  { immediate: true },
);

// 生命周期钩子
onMounted(() => {
  if (typeof window !== "undefined") {
    if (!window.pageFields) {
      window.pageFields = {};
    }
    lastName.value = props.config.name;
    window.pageFields[props.config.name] = {
      setValue,
      getValue
    };
  }
});

onBeforeUnmount(() => {
  if (typeof window !== "undefined" && window.pageFields) {
    delete window.pageFields[props.config.name];
  }
  delete window[`on${props.config.name}ValueChange`];
});

// 方法
const setValue = v => {
  value.value = v;
};

const getValue = () => {
  return value.value;
};

const search = () => {
  if (typeof window[`on${props.config.name}ValueChange`] === "function") {
    window[`on${props.config.name}ValueChange`](value.value);
  }
  emit("change", value.value);
};

 

let { langJson, nowLocale, getLocaleText } = useLocate();
</script>
  
  <style scoped>
.input-item-wrap {
  height: 100%;
  
  
}
.input-item{
  height: 100%;
  
}

.input-item :deep(.el-input__inner){
  height: 100%;
}
</style>
  
